export const uiPreferenceKeys = {
  all: ['ui-preferences'] as const,
};
